<template>
  <el-dialog
    :title="$t('deletePartnerGoods.confirmTitle')"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
  >
    <div align="center">
      <p>{{$t('deletePartnerGoods.confirmContent')}}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDeletePartnerGoodsModel">{{$t('deletePartnerGoods.cancel')}}</el-button>
      <el-button type="primary" @click="deletePartnerGoods">{{$t('deletePartnerGoods.confirm')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { deletePartnerGoods } from '@/api/partner/deletePartnerGoodsApi'

export default {
  name: 'DeletePartnerGoods',
  data() {
    return {
      dialogVisible: false,
      deletePartnerGoodsInfo: {}
    }
  },
  methods: {
    open(data) {
      this.deletePartnerGoodsInfo = { ...data }
      this.dialogVisible = true
    },
    deletePartnerGoods() {
      this.deletePartnerGoodsInfo.shopId = getShopId()
      deletePartnerGoods(this.deletePartnerGoodsInfo)
        .then(res => {
          if (res.code === 0) {
            this.$message.success(this.$t('deletePartnerGoods.deleteSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(err => {
          this.$message.error(err.message || this.$t('common.requestFailed'))
        })
    },
    closeDeletePartnerGoodsModel() {
      this.dialogVisible = false
    },
    handleClose(done) {
      done()
    }
  }
}
</script>